/*
 * 查询蓝桥所有灰度接口
 */

// 入参如果传了对应的灰度scene，只查对应的灰度scene，如果不查，默认查所有灰度场景
var SessionKeyName = 'ltl_lq_gray_config'

var UserSessionKeyName = 'ltl_lq_user_gray_config'

export var AdvertisementKeyName = 'advertisement'

// useNew 是否强制不走缓存，默认false
// 登录企业id维度的灰度
export const getAllGrayConfig = function (sceneList, useNew) {
  // sceneList 空数组默认查所有
  var innerSceneList = sceneList || []
  // 优先取缓存
  var temp = sessionStorage.getItem(SessionKeyName)
  var newres = {}
  var useLocal = true
  try {
    if (temp) {
      temp = JSON.parse(temp) || {}
      for (var i = 0; i < innerSceneList.length; i++) {
        // 本地缓存存在一个没匹配到，都要重新走接口
        if (!temp[innerSceneList[i]]) {
          useLocal = false
          break
        }
      }
    }
    // 确认使用本地缓存
    if (temp && useLocal && !useNew) {
      return temp
    }
    // 走接口请求
    $.javaAjax({
      url: '/web/grey/getGreyBusinessSceneConfig',
      type: 'POST',
      isSearchApp: true,
      async: false,
      data: {
        sceneList: innerSceneList
      },
      success: function (res) {
        if (res.success && res.data && res.data.map) {
          newres = res.data.map
          // 先合并已存在的key，不要直接覆盖
          var fdata = Object.assign(temp || {}, newres)
          sessionStorage.setItem(SessionKeyName, JSON.stringify(fdata))
        } else {
          newres = {}
        }
      },
      error: function (res) {
        newres = {}
      }
    })
    return newres
  } catch (error) {
    return {}
  }
}

// 获取登录用户id维度的灰度功能开关
export const getAllUserGrayConfig = function (options) {
  options = options || {}
  var useNew = options.useNew
  // 优先取缓存
  var temp = sessionStorage.getItem(UserSessionKeyName)
  var newres = {}
  try {
    // 确认使用本地缓存
    if (temp && !useNew) {
      temp = JSON.parse(temp) || {}
      return temp
    }
    // 走接口请求
    $.javaAjax({
      url: '/web/system-setting/popConfig/isShow',
      type: 'POST',
      async: false,
      data: {},
      success: function (res) {
        if (res.success && res.data) {
          newres = res.data
          sessionStorage.setItem(UserSessionKeyName, JSON.stringify(res.data))
        } else {
          newres = {}
        }
      },
      error: function (res) {
        newres = {}
      }
    })
    return newres
  } catch (error) {
    return {}
  }
}

export const CloseScenes = {
  insureFloatBtn: 1, // 保险浮动按钮
  topBannerAd: 2, // 上栏广告位 https://wiki.amh-group.com/pages/viewpage.action?pageId=954500595
  printLabelAd: 3 // 打印标签弹窗广告位
}
/*
 * 关闭用户维度的功能开关
 * popType
 */
export const colseUserGrayConfig = function (popType, callback) {
  if (popType === undefined || popType === null) {
    return
  }
  $.javaAjax({
    type: 'POST',
    url: '/web/system-setting/popConfig/close',
    data: { popType: popType },
    dataType: 'json',
    error: function (XMLHttpRequest, textStatus, errorThrown) {
      alert('失败:' + errorThrown)
    },
    success: function (result) {
      sessionStorage.removeItem(UserSessionKeyName)
      callback && callback(result)
    }
  })
}

// 广告查询与灰度场景结合的深，查询广告接口通用逻辑也写在这里
export const getAllCommonAD = function (options) {
  options = options || {
    noCache: false,
    advertisementFilterKey: ''
  }
  var adRes = {}
  try {
    adRes = JSON.parse(sessionStorage.getItem(AdvertisementKeyName) || '{}')
    // 优先取缓存
    if (adRes && adRes.advertisement && !options.noCache) {
      // 根据传入的位置做筛选
      if (options.advertisementFilterKey && adRes.advertisement.length) {
        var newAdvertisement = adRes.advertisement.filter(function (ele) {
          return ele.areaCodeStr && ele.areaCodeStr.indexOf(options.advertisementFilterKey) != -1
        })
        adRes.advertisement = newAdvertisement || []
      }
      return adRes
    }
  } catch (error) {}

  $.javaAjax({
    url: '/web/advertisementSetting/getAll',
    type: 'POST',
    async: false,
    success: result => {
      if (result.data) {
        adRes = result.data
        sessionStorage.setItem(AdvertisementKeyName, JSON.stringify(result.data))
      } else {
        sessionStorage.setItem(AdvertisementKeyName, JSON.stringify({}))
      }
    }
  })
   // 根据传入的位置做筛选
   if (options.advertisementFilterKey && adRes.advertisement.length) {
    var newAdvertisement = adRes.advertisement.filter(function (ele) {
      return ele.areaCodeStr && ele.areaCodeStr.indexOf(options.advertisementFilterKey) != -1
    })
    adRes.advertisement = newAdvertisement || []
  }
  return adRes
}
